var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMomentumReversalsPeaking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.096 11.316a1.25 1.25 0 011.715.05l12.688 12.688v-8.237a1.25 1.25 0 012.501 0v11.257c0 .69-.56 1.25-1.25 1.25H24.492a1.25 1.25 0 110-2.501h8.237L20.876 13.969 5.082 28.009a1.25 1.25 0 01-1.662-1.87l16.676-14.823z"
  })));
}
export default SvgMomentumReversalsPeaking;